import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, NavigationToggler, Option, Text } from '@common-fe/common-fe';

import { Modal } from '@/components';

import ProofOfNecessityTab from './components/ProofOfNecessityTab/ProofOfNecessityTab';
import ReceiptIsRequiredWarning from './components/ReceiptIsRequiredWarning/ReceiptIsRequiredWarning';
import ReceiptsTab from './components/ReceiptsTab/ReceiptsTab';
import SavedReceiptsFooter from './components/SavedReceiptsFooter/SavedReceiptsFooter';
import { SavedReceiptsTab } from './SavedReceiptsPopup.types';

interface Props {
  onSetVisible: (value: boolean) => void;
}

const SavedReceiptsPopupContainer: React.FC<Props> = ({ onSetVisible }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(SavedReceiptsTab.PROOF_OF_NECESSITY);

  const options = useMemo<Option[]>(() => [
    {
      key: SavedReceiptsTab.RECEIPTS,
      value: SavedReceiptsTab.RECEIPTS,
      title: t('Receipts'),
    },
    {
      key: SavedReceiptsTab.PROOF_OF_NECESSITY,
      value: SavedReceiptsTab.PROOF_OF_NECESSITY,
      title: t('Proof of Necessity'),
    }, 
  ], [t]);

  return (
    <Modal
      visible
      onSetVisible={onSetVisible}
      testId="upload-file"
    >
      <Text
        data-testid="upload-file-modal_title"
        size="2xl"
        weight={700}
        textAlign="center"
      >
        {t('Select a Document')}
      </Text>
      
      <Box margin={{ top: 'spacing16' }}>
        <NavigationToggler
          containerStyle={{ width: '100%', justifyContent: 'center' }}
          value={activeTab}
          onChange={setActiveTab}
          options={options}
        />
      </Box>

      {activeTab === SavedReceiptsTab.RECEIPTS && (
        <ReceiptsTab margin={{ top: 'spacing16' }} />
      )}

      {activeTab === SavedReceiptsTab.PROOF_OF_NECESSITY && (
        <ProofOfNecessityTab margin={{ top: 'spacing16' }} />
      )}

      {activeTab === SavedReceiptsTab.PROOF_OF_NECESSITY && (
        <ReceiptIsRequiredWarning
          margin={{ top: 'spacing24' }}
          setActiveTab={setActiveTab}
        />
      )}

      <SavedReceiptsFooter
        margin={{ top: 'spacing24' }}
        onSetVisible={onSetVisible}
      />
    </Modal>
  );
};

export default SavedReceiptsPopupContainer;
